import { BaseMutations } from '@/store/base-mutations';
import { Reports } from '@/modules/reports/types';
import { default_orders_reports_filters } from '@/modules/reports/services';
import ReportsState from './state';

export default class ReportsMutations extends BaseMutations<ReportsState> {
  SET_REPORTS(reports: Reports.Report[]) {
    this.state.reports = reports;
  }

  SET_TOTAL(total: Reports.OrdersReportsTotalInfo) {
    this.state.total = total;
  }

  SET_REPORT_ORDER_FILTERS(filters: Reports.ReportOrderFilters) {
    this.state.report_order_filters = filters;
  }

  UPD_SHOW_TABLES(value: boolean) {
    this.state.show_tables = value;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof Reports.OrdersReportsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  RESET_PAYLOAD() {
    this.state.filters = default_orders_reports_filters();
  }

  SET_PERMISSIONS(permission: Reports.Permission[]) {
    this.state.permissions = permission;
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  TOGGLE_FILTERS_EXIST(toggle: boolean) {
    this.state.filters_exist = toggle;
  }

  TOGGLE_FILTERS_CHANGED(toggle: boolean) {
    this.state.filters_changed = toggle;
  }

  TOGGLE_TOTAL_EXIST(toggle: boolean) {
    this.state.total_exist = toggle;
  }
}
